import React from 'react';
import { useTranslation } from 'react-i18next';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineDot from '@mui/lab/TimelineDot';
import Avatar from '@mui/material/Avatar';

import { stringToColor } from 'routes/BudgetModule/components/shared/InscriptionsGrid/InscriptionDetails/helpers/styleHelpers';
import { useCreateInscriptionComment } from 'routes/BudgetModule/components/shared/InscriptionsGrid/InscriptionDetails/inscriptionCommentQuery';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineContent from '@mui/lab/TimelineContent';
import { styled } from '@mui/material/styles';
import CommentTextField from './CommentTextField';
import { StyHeader, StyHighlightedText } from './StyledComponents';

type Props = {
    isLastItem: boolean;
    inscriptionId: number;
    loggedInUserEmail: string;
};

const StyAvatar = styled(Avatar, {
    name: 'StyAvatar',
})({
    width: '20px',
    height: '20px',
    fontSize: '15px',
});

function CommentField({
    isLastItem = false,
    inscriptionId,
    loggedInUserEmail,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const [value, setValue] = React.useState('');
    const [disableButton, setDisableButton] = React.useState(false);

    const { mutate: createInscriptionComment } = useCreateInscriptionComment(
        inscriptionId,
        setDisableButton,
    );

    const sendComment = () => {
        setDisableButton(true);
        createInscriptionComment(value);
    };

    return (
        <TimelineItem>
            <TimelineOppositeContent sx={{ padding: 0, flex: 0 }} />
            <TimelineSeparator>
                <TimelineDot
                    sx={{
                        backgroundColor: stringToColor(loggedInUserEmail),
                    }}
                >
                    <StyAvatar
                        sx={{
                            backgroundColor: stringToColor(loggedInUserEmail),
                        }}
                    >
                        {loggedInUserEmail[0].toUpperCase()}
                    </StyAvatar>
                </TimelineDot>
                {!isLastItem && <TimelineConnector />}
            </TimelineSeparator>
            <TimelineContent sx={{ paddingRight: 0 }}>
                <StyHeader>
                    <StyHighlightedText>
                        {t('budgetHistory.comment')}
                    </StyHighlightedText>
                </StyHeader>
                <CommentTextField
                    setValue={setValue}
                    value={value}
                    sendComment={sendComment}
                    disableButton={disableButton}
                    canEdit
                />
            </TimelineContent>
        </TimelineItem>
    );
}

export default CommentField;
